import React, { useMemo }  from 'react'
import DropDown from '../dropdown';
import PropTypes from "prop-types";
import {RoomTypes} from '../../../api/services/next'

const RoomTypesDropDown = ({HotelIDs,...rest}) => {
    const spec = useMemo(() => {
        return { HotelIds: HotelIDs }
    }, [HotelIDs])
    return <DropDown api={RoomTypes.GetRoomTypes} spec={spec} textField="Name" valueField="Id" {...rest}/>
}
RoomTypesDropDown.propTypes = {
    HotelIDs: PropTypes.any
}
export default RoomTypesDropDown
